<template>
    <div class="coupon-card" :data-status="info.status">
        <div class="amount"><i>￥</i>{{info.amount/100 | number_format}}</div>
        <div class="title">{{info.title}}</div>
        <div class="bottom">
            <span>有效期：</span>
            <span>{{info.startTime*1000 | date_format}}</span>
            <span style="margin: 0 3px">至</span>
            <span>{{info.endTime*1000 | date_format}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        props:{
            info:{

            }
        }
    }
</script>

<style lang="scss" scoped>
    .coupon-card{
        display: inline-block;
        position: relative;
        width: 415px;
        height: 128px;
        color: #fff;
        background-image: url("../../assets/images/coupon/1.png");
        background-size: cover;
        border-radius: 8px;
        padding: 20px 30px 30px 30px;
        overflow: hidden;
        margin-right: 10px;
        &[data-status='2'],&[data-status='3']{
            background-image: url("../../assets/images/coupon/2.png");
        }
        .amount{
            font-size: 24px;
            margin-bottom: 5px;
            letter-spacing: 1px;
            i{
                font-style: normal;
                font-size: 20px;
            }
        }
        .title{
            font-size: 16px;
            letter-spacing: 1px;
        }
        .bottom{
            height: 26px;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #AD8A6A;
            font-size: 12px;
            line-height: 26px;
            padding-left: 30px;
        }
    }
</style>